<template>
  <div class="wallet-container">
    <div
      class="head van-hairline--right"
      @click="$router.push({ name: 'Wallet' })"
    >
      <img :src="require('@/assets/mine/钱包.svg')" alt="" />
      <div class="tit">我的钱包</div>
    </div>
    <div class="menu">
      <div class="item" @click="$router.push({ name: 'Wallet' })">
        <div class="num">{{ withdrawAmount }}</div>
        <div class="tit">我的余额</div>
      </div>
      <div class="item" @click="$router.push({ name: 'Coupon' })">
        <div class="num">{{ couponNum }}</div>
        <div class="tit">优惠券</div>
      </div>
      <div class="item" @click="$router.push({ name: 'Redpack' })">
        <div class="num">{{ redpackNum }}</div>
        <div class="tit">我的红包</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWallet } from "@/api/wallet";
import { getRedpackList, getMyCoupon } from "../webApi";
export default {
  data() {
    return {
      withdrawAmount: 0,
      redpackNum: 0,
      couponNum: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const customerId = this.$store.state.user.customerId;
      getWallet(customerId).then((res) => {
        this.withdrawAmount = res.data.withdrawAmount;
      });
      getRedpackList(true).then(({ data }) => {
        this.redpackNum = data.length;
      });
      getMyCoupon({ couponStatus: 0 }).then(({ data }) => {
        this.couponNum = data.length;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wallet-container {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  margin-bottom: 16px;
  display: flex;
  text-align: center;
  .tit {
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    padding-top: 6px;
  }
  .head {
    padding: 16px 26px 26px;
    img {
      width: 52px;
      height: 52px;
      margin: 0 auto;
    }
  }
  .menu {
    display: flex;
    flex: 1;
    min-width: 0;
    padding-top: 20px;
    padding-bottom: 28px;
    padding-left: 30px;
    .item {
      flex: 1;
      .num {
        font-weight: 800;
        font-size: 40px;
        line-height: 54px;
        height: 54px;
      }
      .tit {
        padding-top: 0;
      }
    }
  }
}
</style>